import { QrDisplayConfig } from "../types/qr-display-config";
import BaseService from "./base-service";
import { RequestDto } from "./dto/request/request-dto";

export class QrDisplayConfigService extends BaseService {
  async getConfigs(
    onSuccess: (data: QrDisplayConfig[]) => void,
    onError: (errorMessage: string) => void,
    branchId?: number
  ) {
    const query = branchId ? `?branchid=${branchId}` : "";
    const reqParams = new RequestDto(`/api/qr-display-configs${query}`, {});
    await this.doGet<QrDisplayConfig[]>(reqParams, onSuccess, onError);
  }
}
